/**
 * useVariantInputImagePolicy — the bought variant's `inputImagePolicy`.
 *
 * Read from the VARIANT rather than the shell, because the two disagree on the
 * same flow: `2D_FLOOR_PLAN_EDITING` is `UNLIMITED` while
 * `MOBILE_APPLICATION_FLOOR_PLAN` is `NONE`, and both announce `floor_plan_config`.
 * A shell-level answer would either demand a file from a product drawn on site or
 * let an editing line order nothing to edit.
 *
 * Returns `undefined` until the catalogue resolves, which every caller must treat
 * as "no requirement yet" — a gate that fires on a not-yet-loaded catalogue locks
 * the client out of their own configuration for a frame.
 */

import type { CartItemId, InputImagePolicyV2 } from 'models/purchaseFlowRevamp'

import { useCartLineCatalogueEntry } from '../useCartLineCatalogueEntry'

export function useVariantInputImagePolicy(cartItemId: CartItemId): InputImagePolicyV2 | undefined {
  return useCartLineCatalogueEntry(cartItemId).variant?.inputImagePolicy
}
